import { jsx, jsxs } from 'react/jsx-runtime';
import 'date-fns-tz';
import 'clsx';
import 'tailwind-merge';
import { Button } from '../page-layout/Button.js';
import { Alert, AlertTitle, AlertDescription } from '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import { AlertCircle } from 'lucide-react';
import { useState } from 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog.js';
import '@radix-ui/react-popover';
import { Label } from '../ui/label.js';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '@radix-ui/react-dialog';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import './CrudDetailView.js';
import './CrudFormView.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@clerk/clerk-react';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';
import '../../lib/toast.js';
import { PaginatedCombobox } from '../form/PaginatedCombobox.js';
import '../form/RichTextEditor.js';

/**
 * Modal for adding/selecting an item from a paginated list
 * Used in CRUD list views with the "add" action enabled
 */
function AddItemModal({ open, onOpenChange, entityName, entityNamePlural, onAdd, getItems, getValueFromItem, getLabelFromItem, modalConfig = {}, }) {
    const [selectedItemId, setSelectedItemId] = useState('');
    const [selectedItem, setSelectedItem] = useState();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        try {
            setError(null);
            e.preventDefault();
            if (!selectedItem) {
                return setError(`Please select a ${entityName.toLowerCase()}.`);
            }
            setLoading(true);
            await onAdd(selectedItem);
            // Reset state on success
            setSelectedItemId('');
            setSelectedItem(undefined);
            setError(null);
            setLoading(false);
        }
        catch (err) {
            const errorMessage = err?.message || `Failed to add ${entityName.toLowerCase()}. Please try again.`;
            setError(errorMessage);
            setLoading(false);
        }
    };
    const handleClose = () => {
        setSelectedItemId('');
        setSelectedItem(undefined);
        setError(null);
        setLoading(false);
        onOpenChange(false);
    };
    return (jsx(Dialog, { open: open, onOpenChange: handleClose, children: jsx(DialogContent, { className: "sm:max-w-[500px]", children: jsxs("form", { onSubmit: handleSubmit, children: [jsxs(DialogHeader, { children: [jsx(DialogTitle, { children: modalConfig.title || `Add ${entityName}` }), jsx(DialogDescription, { children: modalConfig.description ||
                                    `Search and select ${getLabelFromItem.length > 0 ? 'an' : 'a'} ${entityName.toLowerCase()}.` })] }), error && (jsxs(Alert, { variant: "destructive", className: "mt-4", children: [jsx(AlertCircle, { className: "h-5 w-5" }), jsx(AlertTitle, { children: "Error" }), jsx(AlertDescription, { children: error })] })), jsx("div", { className: "grid gap-4 py-4", children: jsxs("div", { className: "grid gap-2", children: [jsx(Label, { htmlFor: "item", children: modalConfig.fieldLabel || entityName }), jsx(PaginatedCombobox, { getData: getItems, getValueFromItem: getValueFromItem, getLabelFromItem: getLabelFromItem, value: selectedItemId, onValueChange: (value, item) => {
                                        setSelectedItemId(value);
                                        setSelectedItem(item);
                                    }, placeholder: modalConfig.placeholder ||
                                        `Select ${getLabelFromItem.length > 0 ? 'an' : 'a'} ${entityName.toLowerCase()}...`, searchPlaceholder: modalConfig.searchPlaceholder || `Search ${entityNamePlural.toLowerCase()}...`, emptyMessage: modalConfig.emptyMessage || `No ${entityNamePlural.toLowerCase()} found.`, pageSize: 20 })] }) }), jsxs(DialogFooter, { children: [jsx(Button, { type: "button", variant: "outline", onClick: handleClose, children: "Cancel" }), jsx(Button, { type: "submit", disabled: !selectedItemId || loading, loading: loading, children: modalConfig.submitText || `Add ${entityName}` })] })] }) }) }));
}

export { AddItemModal };
//# sourceMappingURL=AddItemModal.js.map
